<template>
    <div id="scale-sidebar-menu" class="sidebar-menu-container">
        <div class="sidebar-main-label">Масштаб</div>
        <div class="sidebar-text-area">Установите масштаб проекта. Поставьте две точки в рабочей области таким образом, чтобы <span class="red-text bold-text">длина</span> получившегося отрезка <span class="red-text bold-text">на реальном объекте</span> была вам <span class="red-text bold-text">точно известна</span>. Примерами такого отрезка могут быть длина стены или высота двери.</div>
        <div class="sidebar-step-two-img-container">
            <img class="sidebar-step-two-img" :src="urlForStatic('/img/projectPreviewsDemo/perspective_tip_1.svg')"/>
        </div>
        <div class="sidebar-text-area">Старайтесь выбирать объекты, которые находятся как можно <span class="red-text bold-text">ближе</span> к наблюдателю и находятся под близким к <span class="red-text bold-text">прямому углу</span> к точке обзора. Это увеличит точность визуализации и расчетов</div>
    </div>
</template>

<script>
    import {urlForStaticVue} from "../../common";

    export default {
        name: "ScaleSidebarMenu",
        mixins: [urlForStaticVue]
    }
</script>

<style scoped>

</style>
